<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form class="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Correo electronico</label
                >
                <div class="col-md-9">
                    <input
                        type="email"
                        v-model="email"
                        class="form-control"
                        placeholder="Correo electronico"
                    />
                    <span v-if="allerrors.email" :class="['show-error']">{{
                        allerrors.email[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Nombre</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="name"
                        class="form-control"
                        placeholder="Nombre"
                    />
                    <span v-if="allerrors.name" :class="['show-error']">{{
                        allerrors.name[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Contraseña</label
                >
                <div class="col-md-9">
                    <input
                        type="password"
                        v-model="password"
                        class="form-control"
                        placeholder="Contraseña"
                    />
                    <span v-if="allerrors.password" :class="['show-error']">{{
                        allerrors.password[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Resumen</label
                >
                <div class="col-md-9">
                    <ckeditor
                        :editor="editor"
                        v-model="summary"
                        :config="editorConfig"
                    ></ckeditor>
                    <span v-if="allerrors.summary" :class="['show-error']">{{
                        allerrors.summary[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger"></div>
                    <span v-if="allerrors.image" :class="['show-error']">{{
                        allerrors.image[0]
                    }}</span>
                    <a
                        v-if="image_path"
                        :href="image_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-3"></div>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger-webp"></div>
                    <span v-if="allerrors.image_webp" :class="['show-error']">{{
                        allerrors.image_webp[0]
                    }}</span>
                    <a
                        v-if="image_webp_path"
                        :href="image_webp_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Alt image</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="text_image_alt"
                        class="form-control"
                        placeholder="Alt image"
                    />
                    <span
                        v-if="allerrors.text_image_alt"
                        :class="['show-error']"
                        >{{ allerrors.text_image_alt[0] }}</span
                    >
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Activo</label
                >
                <div class="col-md-9">
                    <input type="checkbox" v-model="is_active" />
                    <span v-if="allerrors.is_active" :class="['show-error']">{{
                        allerrors.is_active[0]
                    }}</span>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Agregar
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
        <template-uploader></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-webp"
            text_button="Imagen webp"
        ></template-uploader>
    </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import qq from "fine-uploader";
import "fine-uploader/fine-uploader/fine-uploader-new.min.css";
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            action: "",
            summary: null,
            email: null,
            name: null,
            image: null,
            text_image_alt: null,
            is_active: false,
            password: null,
            image_path: null,
            image_webp: null,
            image_webp_path: null,
            allerrors: {
                summary: null,
                email: null,
                name: null,
                password: null,
                image: null,
                image_webp: null,
                text_image_alt: null,
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: ["bold", "italic", "underline"],
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/judges/show/" + me.model_id)
                .then(function (response) {
                    me.name = response.data.model.name;
                    me.summary = response.data.model.summary;
                    me.image = response.data.model.image;
                    me.image_webp = response.data.model.image_webp;
                    me.text_image_alt = response.data.model.text_image_alt;
                    me.email = response.data.model.email;
                    me.is_active = response.data.model.is_active;
                    me.image_path = response.data.image_path;
                    me.image_webp_path = response.data.image_webp_path;
                })
                .catch(function (error) {});
        },
        create() {
            let me = this;
            if (me.validForm()) {
                axios
                    .post(me.action, {
                        summary: me.summary,
                        name: me.name,
                        image: me.image,
                        image_webp: me.image_webp,
                        text_image_alt: me.text_image_alt,
                        email: me.email,
                        password: me.password,
                        is_active: me.is_active,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(me.action, {
                        summary: me.summary,
                        name: me.name,
                        image: me.image,
                        image_webp: me.image_webp,
                        text_image_alt: me.text_image_alt,
                        email: me.email,
                        password: me.password,
                        is_active: me.is_active,
                    })
                    .then(function (response) {
                        me.image_path = response.data.image_path;
                        me.image_webp_path = response.data.image_webp_path;
                        me.clearError();
                        me.showActionSuccess("Actualizacion exitosa!");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.name) {
                me.allerrors.name = ["El campo nombre es obligatorio."];
                valid = false;
            } else if (me.name.length > 50) {
                me.allerrors.name = [
                    "El campo nombre debe tener máximo 50 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.name = [""];
            }
            if (!me.summary) {
                me.allerrors.summary = ["El campo resumen es obligatorio."];
                valid = false;
            } else if (me.summary.length > 150) {
                me.allerrors.summary = [
                    "El campo resumen debe tener máximo 150 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.summary = null;
            }

            if (!me.email) {
                me.allerrors.email = ["El campo email es obligatorio."];
                valid = false;
            } else {
                me.allerrors.email = null;
            }
            if (!me.image) {
                me.allerrors.image = ["El campo imagen es obligatorio."];
                valid = false;
            }

            if (me.text_image_alt && me.text_image_alt.length > 190) {
                me.allerrors.text_image_alt = [
                    "El campo image alt debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.text_image_alt = null;
            }

            if (
                me.password &&
                (me.password.length > 12 || me.password.length < 8)
            ) {
                me.allerrors.password = [
                    "El campo contraseña debe tener entre 8 y 12 caracteres.",
                ];
                valid = false;
            } else {
                me.allerrors.password = null;
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                summary: null,
                email: null,
                name: null,
                password: null,
                image: null,
                image_webp: null,
                text_image_alt: null,
            };
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
        getUploadImageUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-image`;
        },
        getDeleteFileUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/delete-file`;
        },
    },
    mounted() {
        let me = this;
        if (me.model_id == 0) {
            me.action = "/api/judges";
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                deleteFile: {
                    enabled: true, // defaults to false
                    endpoint: this.getDeleteFileUrl(),
                },
                template: "qq-template-manual-trigger",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    itemLimit: 1,
                    sizeLimit: 20971520,
                    image: {
                        maxHeight: 200,
                        minHeight: 200,
                        maxWidth: 213,
                        minWidth: 213,
                    },
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                    maxWidthImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    minWidthImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    maxHeightImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    minHeightImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image"] = null;
                            me.image = response.path;
                        } else {
                            me.allerrors["image"] = ["Error en la imagen"];
                        }
                    },
                    onDeleteComplete: function (id, name, response) {
                        me.allerrors["image"] = null;
                        me.image = "";
                    },
                },
                multiple: false,
            });

            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger-webp"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                deleteFile: {
                    enabled: true, // defaults to false
                    endpoint: this.getDeleteFileUrl(),
                },
                template: "qq-template-manual-trigger-webp",
                validation: {
                    allowedExtensions: ["webp"],
                    itemLimit: 1,
                    sizeLimit: 20971520,
                    image: {
                        maxHeight: 200,
                        minHeight: 200,
                        maxWidth: 213,
                        minWidth: 213,
                    },
                },
                messages: {
                    noFilesError: "Seleccione una imagen de tipo webp.",
                    maxWidthImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    minWidthImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    maxHeightImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    minHeightImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image_webp"] = null;
                            me.image_webp = response.path;
                        } else {
                            me.allerrors["image_webp"] = ["Error en la imagen"];
                        }
                    },
                    onDeleteComplete: function (id, name, response) {
                        me.allerrors["image_webp"] = null;
                        me.image_webp = "";
                    },
                },
                multiple: false,
            });
        } else {
            this.getModel();
            me.action = "/api/judges/update/" + me.model_id;
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                template: "qq-template-manual-trigger",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    sizeLimit: 20971520,
                    image: {
                        maxHeight: 200,
                        minHeight: 200,
                        maxWidth: 213,
                        minWidth: 213,
                    },
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                    maxWidthImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    minWidthImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    maxHeightImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    minHeightImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image"] = null;
                            me.image = response.path;
                        } else {
                            me.allerrors["image"] = ["Error en la imagen"];
                        }
                    },
                },
                multiple: false,
            });

            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger-webp"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                template: "qq-template-manual-trigger-webp",
                validation: {
                    allowedExtensions: ["webp"],
                    sizeLimit: 20971520,
                    image: {
                        maxHeight: 200,
                        minHeight: 200,
                        maxWidth: 213,
                        minWidth: 213,
                    },
                },
                messages: {
                    noFilesError: "Seleccione una imagen de tipo webp.",
                    maxWidthImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    minWidthImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    maxHeightImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                    minHeightImageError:
                        "Dimensiones incorrectas debe ser de 213x200 px.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image_webp"] = null;
                            me.image_webp = response.path;
                        } else {
                            me.allerrors["image_webp"] = ["Error en la imagen"];
                        }
                    },
                },
                multiple: false,
            });
        }
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
